import RoktAdPlacement from 'components/RoktAdPlacement/RoktAdPlacement';

export default RoktAdPlacement;
